import React, { Fragment } from "react";
import { Checkbox, Chip, makeStyles } from "@material-ui/core";
import styles from "../../../styles/global-styles";
import StyleTableRow from "../../../styles/styleTableRow";
import StyledTableCell from "../../../styles/tableCell";
import { customDate } from "../../../_utils/utils";

const useStyles = makeStyles((theme) => ({
  chip: styles.chip,
  errorChip: styles.errorChip,
  returnChip: styles.returnChip,
  warningChip: styles.warningChip,
  successfullChip: styles.successfullChip,
  secondaryChip: styles.secondaryChip,
}));

const DistributionBySiteTableBody = ({
  distributionsArray,
  distributionSection,
  page,
  rowsPerPage,
  distributionSelected,
  selectedExam,
}) => {
  const classes = useStyles();
  const isSelected = (id) => selectedExam.indexOf(id) !== -1;

  const isItemSelected = (row) => isSelected(row.id);

  const colorChipStatus = (status) => {
    switch (status) {
      case 1:
        return classes.chip;
      case 2:
        return classes.successfullChip;
      case 3:
        return classes.warningChip;
      case 4:
        return classes.errorChip;
      case 5:
        return classes.returnChip;

      default:
        return classes.chip;
    }
  };

  return (
    <Fragment>
      {distributionsArray.length &&
        distributionsArray
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, i) => (
            <StyleTableRow
              hover
              role="checkbox"
              aria-checked={isItemSelected}
              tabIndex={-1}
              key={i}
              className={classes.rowSelected}
              selected={isItemSelected(row)}
            >
              <StyledTableCell padding="checkbox">
                <Checkbox
                  checked={isItemSelected(row)}
                  onClick={(event) =>
                    distributionSelected(
                      event,
                      row.id,
                      row.statusDistributionId
                    )
                  }
                  color="primary"
                />
              </StyledTableCell>
              <StyledTableCell align="center" style={{ fontWeight: 700 }}>
                {row.lote}
              </StyledTableCell>
              <StyledTableCell align="center">
                {row.product?.product_type?.name}
              </StyledTableCell>
              <StyledTableCell align="center">
                {row.product.accesory?.subcategory_type?.name || "N/A"}
              </StyledTableCell>
              <StyledTableCell align="center" style={{ fontWeight: 600 }}>
                {row.product.movile?.brand} {row.product?.movile?.model}
                {row.product.accesory?.brand} {row.product.accesory?.model}
                {row.product.cash_card?.card_catalogue?.name}{" "}
                {row.product.cash_card?.card_catalogue?.amount}
                {row.product.chip?.chip_catalogue?.name}
              </StyledTableCell>
              <StyledTableCell align="left">
                {row.product.movile?.imeiCode || "N/A"}{" "}
              </StyledTableCell>
              <StyledTableCell align="center">
                {row.product.movile?.barCode ||
                  row.product.accesory?.barCode ||
                  row.product.chip?.lote ||
                  "N/A"}
              </StyledTableCell>
              <StyledTableCell align="center">
                <Chip
                  label={row.status_distribution?.status || "Sin definir"}
                  className={colorChipStatus(row.statusDistributionId)}
                />
              </StyledTableCell>

              <StyledTableCell align="center">
                {customDate(row.updatedAt)}
              </StyledTableCell>
            </StyleTableRow>
          ))}
    </Fragment>
  );
};

export default DistributionBySiteTableBody;
